import React from 'react'

import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Master from './views/master/Master'
import TestRequest from './views/sections/TestRequest'
import TerminosCondiciones from './views/sections/TerminosCondiciones'
import DatosDigitales from './views/sections/DatosDigitales'
import ReservaYa from './views/sections/ReservaYa'
import EasyBuy from './views/sections/EasyBuy'
import EasyBuyTrial from './views/sections/EasyBuyTrial'

import './App.css'
import './Global'
import './components/i18n'

const basename = process.env.NODE_ENV === 'production' ? '/' : '/'

function App() {
  return (
    <>
      <BrowserRouter basename={basename}>
        <Routes>
          <Route
            path={global.ROUTE_LOGIN}
            caseSensitive={false}
            element={<Master />}
          />

          <Route
            path={global.TEST_REQUEST}
            caseSensitive={false}
            element={<TestRequest />}
          />

          <Route
            path={global.TERM_CONDITION}
            caseSensitive={false}
            element={<TerminosCondiciones />}
          />

          <Route
            path={global.DIGITAL_DATA}
            caseSensitive={false}
            element={<DatosDigitales />}
          />

          <Route
            path={global.RESERVA_YA}
            caseSensitive={false}
            element={<ReservaYa />}
          />

          <Route
            path={global.EASYBUY}
            caseSensitive={false}
            element={<EasyBuy />}
          />

          <Route
            path={global.EASYBUY_TRIAL}
            caseSensitive={false}
            element={<EasyBuyTrial />}
          />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App
